<div class="page-no-found-content">
  <h2 style="font-size: 4em;color: #fff;"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h2>
  <h3>Oops! Funcionalidad no encontrada.</h3>
  <h4>No pudimos encontrar la página que estaba buscando.<br>Por favor de click para regresar al dashboard o
    intente ingresando una url valida.</h4>
  <a [routerLink]="['/dashboard']">
    Volver al Dashboard
  </a>
</div>
